import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, finalize } from 'rxjs/operators';
import { HttpRequestService } from './http-request.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { TranslationService } from './translation.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptorService implements HttpInterceptor {
  //translation
  browserLang: any;
  errorMsg;
  public time: any;
  public count: number = 0;
  private totalRequests = 0
  constructor(private toaster: ToastrService, private spinner: NgxSpinnerService, private router: Router, private lang: TranslationService, private translate: TranslateService) {


    this.translate.get('error').subscribe(res => {

      this.errorMsg = res
      // console.log("error dictonary", this.errorMsg);

    })
  }

  //translation
  langChnaged() {
    this.translate.use(this.browserLang.match(/en-US|hi-IN|mr-IN|bn-IN/) ? this.browserLang : 'en-US')
  }




  showError(message: any, title?: string) {
    if (message && String(message).trim() !== '') {
      this.toaster.error(message, title);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.totalRequests++
    this.spinner.show();
    const headerToken = "12ahsbsb2-12jzc-12zcndfnfd";
    const isExternalApi = req.url.includes('googleapis.com') || req.url.includes('youtube.com') || /\.(pdf|png|jpg|jpeg|gif|webp|svg|xlsx|xls|docx|doc)(\?.*)?$/i.test(req.url);
    const reqWithAuth = isExternalApi ? req : req.clone({
      setHeaders: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,

      }
    })

    return next.handle(reqWithAuth).pipe(


      // retry(1),
      finalize(() => {

        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.spinner.hide()
        }

      }),

      catchError((error: HttpErrorResponse) => {

        const errDetail = error?.error?.detail || error?.error?.message || (error?.error?.data && Array.isArray(error?.error?.data) && error?.error?.data[0]?.message) || '';
        const errCode = error?.error?.code || '';
        if (errCode === 'confirm_logout_required' || (typeof errDetail === 'string' && (errDetail.includes('active on another device') || errDetail.includes('actively logged in')))) {
          return throwError(error);
        }

        if (!navigator.onLine) {
          this.spinner.hide();
          this.showError("No internet connection. Please check your network.", "Connection Error");
          return throwError(error);
        }

        if (error.status == 0) {
          this.spinner.hide();
          this.showError("Unable to connect to the server. Please check your internet connection or try again later.", "Server Unreachable");
          return throwError(error);
        }

        // console.log("error response--->",error);
        if (error.status == 500) {
          this.spinner.hide()
          console.log("somthing went wrong");


        }

        if (error.status == 403) {
          if (error?.error?.detail) {
            this.showError(error.error.detail);
          } else if (error?.error?.message) {
            this.showError(error.error.message);
          } else {
            this.showError("Permission not granted");
          }
        }

        if (error.status == 401) {
          if (error?.error?.data && Array.isArray(error.error.data) && error.error.data.length > 0 && error.error.data[0]?.field == "account_locked") {
            if (error.error.login_attempted_date != undefined && error.error.login_attempted_date != null &&
              error.error.login_attempted_date != '') {

              const d = new Date(error.error.login_attempted_date);
              d.setMinutes(d.getMinutes() + 30);
              this.time = d.getHours() + ':' + d.getMinutes();
            }
          }
          else {
            if (error?.error?.status == "error_logged_out" && error?.error?.data?.message == "User is not logged in") {
              localStorage.clear();
              if (this.count == 0) {
                this.count = this.count + 1;
                this.showError("You are Logout Successfully ");
                this.router.navigateByUrl('/auth');
              }
            }
            else {
              console.log("user is not authorized");
              if (error?.error?.code === 'confirm_logout_required' || (error?.error?.detail && typeof error.error.detail === 'string' && error.error.detail.includes('active on another device'))) {
                // Let AuthComponent handle confirm_logout_required via confirmation modal, suppress toastr
                return throwError(error);
              }
              else if (error?.error?.detail && error?.error?.detail != "Permission not Found ") {
                this.showError(error.error.detail);
              }
              else if (error?.error?.data && Array.isArray(error.error.data) && error.error.data.length > 0 && error.error.data[0]?.message == "Mobile number does not exist.") {
                this.showError("This Mobile Number is not registered.\nPlease contact Captech. No OTP sent");
                return;
              }
              else if (error?.error?.message) {
                this.showError(error.error.message);
              }
              else {
                if (error?.error?.detail != "Permission not Found ") {
                  this.showError("Permission not granted");
                }
              }
            }
          }

        }
        //  if(error.error.code==400 && error.error.status=="error"){

        //   }
        if (error.error != undefined && error.error.code != undefined && error.error.code == 400 && error.status == 400) {
          if (error.error.data && Array.isArray(error.error.data) && error.error.data.length > 0) {
            this.showError(error.error.data[0].message);
          } else if (error?.error?.detail) {
            this.showError(error.error.detail);
          }
        }
        else if (error.error != undefined && error.error.status_code != undefined && error.error.status_code == 400 && error.status == 400) {
          if (error.error.data && Array.isArray(error.error.data) && error.error.data.length > 0) {
            this.showError(error.error.data[0].message);
          } else if (error?.error?.errors?.non_field_errors?.[0]) {
            this.showError(error.error.errors.non_field_errors[0]);
          } else if (error?.error?.message) {
            this.showError(error.error.message);
          } else if (error?.error?.detail) {
            this.showError(error.error.detail);
          }
        }
        else if (error.error != undefined && error.error.status_code == 400 && error.error.data && Array.isArray(error.error.data) && error.error.data.length > 0) {
          if (error.error.data[0].field == "mobile_no") {
            this.showError("User with this mobile number is already exists.");
          }
        }
        else {
          if (error.status == 400 && error.error?.code && typeof error.error.code === 'string' && error.error.code.indexOf("authentication_failed") > -1) {
          }
          else if (error.status == 400 && error.error?.code && typeof error.error.code === 'string' && error.error.code.indexOf("account_locked") > -1) {


          }
          else if (error.status == 400 && error.error?.code && typeof error.error.code === 'string' && error.error.code.indexOf("try_again") > -1) {

          }

          else {
            // console.log("http response data length", error.error.data.length);
            if (error?.error?.detail && error.status !== 401 && error.status !== 403) {
              this.showError(error.error.detail);
            }
            else if (error?.error?.message && error.status !== 401 && error.status !== 403 && error.status !== 404) {
              this.showError(error.error.message);
            }
            else if (error?.error?.data && Array.isArray(error.error.data)) {
              for (let i = 0; error.error.data.length > i; i++) {

                let msg = (error.error.data[i]?.field ? error.error.data[i].field + " " : "") + (error.error.data[i]?.message || "");

                let convert = msg.replace(/ /g, "_");

                console.log("converted result", convert);

                // custom msg
                if (this.errorMsg && this.errorMsg[convert]) {
                  console.log("front end team msg");
                  this.showError(this.errorMsg[convert]);

                } else {
                  // backend response
                  console.log("backend team msg");
                  if (error.error.data[0]?.field == "account_locked") {
                    this.showError("Your account is temporarily locked for 30 mins due to maximum unsuccessful login attempts, Please try after " + this.time);
                  }
                  else if (error.error.data[i]?.message) {
                    this.showError(error.error.data[i].message);
                  }
                }

              }
            }
          }
        }
        return throwError(error);

      })

    );
  }
}
